export default __webpack_public_path__ + "static/PAPC-807-464fa0bd2fb64e8d77cbdb6e5d42fbd4.jpg";